import { getFeatureToggleClient } from 'infra/featureToggles'

/**
 * Whether a job's relationship manager should be read from the Flock API
 * instead of the CSDesk API.
 */
export default function isFlockRelationshipManagerEnabled(): boolean {
  return getFeatureToggleClient().variation(
    'Worklayer.UseFlockForJobRelationshipManager',
    false,
  )
}
